module.exports = __webpack_public_path__ + "img/bottom.1e83f8e7.png";